import { Component, OnInit, inject } from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DataService} from "../../services/data.service";
import {AccessService} from "../../services/access.service";
import {BackupService} from "../../services/backup.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ViewMode} from "../../interfaces";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-contact-category-detail',
    imports: [NgIf, ReactiveFormsModule],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3>
                        <i class="fa-solid fa-address-book me-2"></i>
                        @switch (viewMode) {
                            @case (ViewMode.INSERT) {
                                Kontaktkategorie anlegen
                            }
                            @case (ViewMode.EDIT) {
                                Kontaktkategorie bearbeiten
                            }
                            @case (ViewMode.VIEW) {
                                Kontaktkategorie
                            }
                        }
                    </h3>
                </div>

                <form [formGroup]="form">
                    <div class="row">
                        <div class="col">
                            <label>Name</label>
                            <input type="text" class="form-control" formControlName="name" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.name }}</p>
                        </div>
                    </div>
                </form>

                <div class="mt-3">
                    @if (viewMode == ViewMode.VIEW) {
                        <button type="button" class="btn btn-primary me-2" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
                        <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
                        <button type="button" class="btn btn-danger float-end" (click)="delete()" [disabled]="category?.contacts != '0'">Löschen</button>
                    } @else if (viewMode == ViewMode.EDIT) {
                        <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
                    } @else if (viewMode == ViewMode.INSERT) {
                        <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()">Speichern</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancel()">Abbrechen</button>
                    }
                </div>

            </div>
        </div>
    `
})
export class ContactCategoryDetailComponent implements OnInit {

    accessService = inject(AccessService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private backupService = inject(BackupService);
    private toastrService = inject(ToastrService);

    ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_category!: string;
    viewMode!: ViewMode;
    category: any;

    ngOnInit(): void {
        this.id_category = this.route.snapshot.paramMap.get('id') ?? '0';
        this.viewMode = this.id_category == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            name: [null, Validators.required],
        });

        if (this.id_category !== '0') {
            this.getCategory();
        }
    }

    getCategory(): void {
        this.dataService.request('ContactCategory/get', {
            id_category: this.id_category
        }).subscribe(response => {
            this.category = response.category;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.category.id,
            name: this.category.name,
        });
    }

    save(): void {
        this.dataService.request('ContactCategory/save', {
            category: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/contactcategory']);
            this.toastrService.success('Die Kontaktkategorie wurde angelegt');
        });
    }

    update(): void {
        this.dataService.request('ContactCategory/update', {
            category: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getCategory();
            this.toastrService.success('Die Kontaktkategorie wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/contactcategory']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
        this.getCategory();
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Die Kontaktkategorie wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('ContactCategory/delete', {
                    id_category: this.id_category
                }).subscribe(() => {
                    this.cancel();
                    this.toastrService.success('Die Kontaktkategorie wurde gelöscht');
                });
            }
        });
    }

}
